module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-2.d61eeeac.png";